<template>
    <div class="c-m-progress-bar">
        <div v-for="(item, index) in form.data.steps" :key="`progress-bar-step-${index}`" class="c-m-progress-bar__step">
            <div class="c-m-progress-bar__circle" :class="{'c-m-progress-bar__circle--active' : index === step}">{{index + 1}}
            </div>
            <div class="c-m-progress-bar__text" :class="{'c-m-progress-bar__text--active' : index === step}">{{form.data.steps[index].barTitle}}</div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import {
        GET_FORM_STEP,
        GET_FORM,
        VALIDATE_FORM_STEP,
        GET_CURRENT_STEP_VALID,
        SET_FORM_STEP
    } from '../../../store/store-models/request-form-model.js';

    export default {
        computed: {
            ...mapGetters({
                step: GET_FORM_STEP,
                stepIsValid: GET_CURRENT_STEP_VALID,
                form: GET_FORM,
            })
        },
        methods: {
            ...mapActions({
                validateFormStep: VALIDATE_FORM_STEP,
                setFormStep: SET_FORM_STEP
            }),
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeProgressBar.vue